class ValueLabel {
    label: string = "";
    value: any = "";

    constructor(argLabel?: string, argValue?: string | null) {
        if(argLabel !== undefined && argValue !== undefined) {
            this.label = argLabel;
            this.value = argValue === null ? "" : argValue;
        }
    }
}

export default ValueLabel;